const quizQuestion = document.querySelector('.quiz-question');
const quizCheckUrl = quizQuestion.getAttribute('data-check-url');
const quizSelectUrl = quizQuestion.getAttribute('data-select-url');
const quizAnswerElements = document.querySelectorAll('.quiz-answer');
const quizNextQuestionButtonContainer = document.querySelector('.quiz-question__button');

function answerClick(event) {
    const answer = event.target.closest('.quiz-answer');
    if(answer.hasAttribute('data-answer-h')) {
        if(quizCheckUrl) {
            const url = new URL(quizCheckUrl);
            url.searchParams.append('h',answer.getAttribute('data-answer-h'));
            const options = {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                }
            };
            fetch(url, options)
                .then(response => {
                    if (!response.ok) throw new Error('Ajax call error: ' + response.status + '. (' + quizCheckUrl + ')');
                    return response.json();
                })
                .then(data => {
                    if(data.status===true) {
                        if(data.result===true) answer.classList.add('correct');
                        else {
                            answer.classList.add('wrong');
                            if(data.correct) {
                                const correctAnswer = document.querySelector('[data-answer-h="' + data.correct + '"]')
                                if(correctAnswer) correctAnswer.classList.add('correct');
                            }
                        }
                        quizAnswerElements.forEach(answer => {
                            answer.removeEventListener("click", answerClick);
                        });
                        quizNextQuestionButton();
                        quizQuestion.classList.add('answered');
                    }
                })
                .catch(error => {
                    console.error('ERROR: ' + error);
                });
        }
        else if(quizSelectUrl) {
            quizSelectAnswerAction(answer);
        }
    }
}

function quizNextQuestionButton() {
    const nextBtnUrl = new URL(window.location.href);
    nextBtnUrl.hash = 'quiz';

    window.history.replaceState({},"",nextBtnUrl.toString());

    let btn = document.createElement('a');
    btn.classList.add('button-02');
    btn.setAttribute('href',nextBtnUrl.toString());
    btn.setAttribute('onclick', 'window.location.reload();');
    btn.innerHTML = (quizQuestion.classList.contains('last-question') ? 'Vyhodnocení kvízu' : 'Další otázka');

    quizNextQuestionButtonContainer.appendChild(btn);
}

function quizSelectAnswerAction(answer) {

    const url = new URL(quizSelectUrl);
    url.searchParams.append('h',answer.getAttribute('data-answer-h'));
    const options = {
        method: 'GET',
        headers: {
            'X-Requested-With': 'XMLHttpRequest'
        }
    };
    fetch(url, options)
        .then(response => {
            if (!response.ok) throw new Error('Ajax call error: ' + response.status + '. (' + quizSelectUrl + ')');
            return response.json();
        })
        .then(data => {
            if(data.status===true) {
                answer.classList.add('selected');
                quizAnswerElements.forEach(answer => {
                    answer.removeEventListener("click", answerClick);
                });
                quizNextQuestionButton();
                quizQuestion.classList.add('answered');
            }
        })
        .catch(error => {
            console.error('ERROR: ' + error);
        });
}

quizAnswerElements.forEach(answer => {
    answer.addEventListener("click", answerClick);
});